export default "__VITE_ASSET__Dlv7Wcwh__"